'use strict';

var addressHelpers = require('./address');
var formHelpers = require('./formErrors');
var billingHelpers = require('./billing');
var scrollAnimate = require('org/components/scrollAnimate');
var shipmentSelector = '';
var sameShippingAddress = '';
var shippingMethodListUpdateTimer;
var shippingMethodListUpdateDefer;
var shippingMethodListUpdateForm;
var Cleave = require('cleave.js').default;
var addressValidationModal = require('../components/shippingAddressValidationModal');

/**
 * Call Address-SaveAddress controller to save address to account
 * @returns {Object} - Promise
 * @param {jQuery} form - The shipping form
 */
function saveAddressToAccount(form) {
    var $saveAddressCheckbox = $('#saveAddress');
    var saveUrl = $saveAddressCheckbox.data('url');
    var deferred = $.Deferred(); // eslint-disable-line
    var shippingForm = form.serializeArray();
    shippingForm.push({
        name: 'shipmentAddressSelector',
        value: shipmentSelector
    });
    if ($saveAddressCheckbox.is(':checked') && saveUrl) {
        return $.ajax({
            url: saveUrl,
            method: 'POST',
            data: shippingForm
        });
    }

    return deferred.resolve();
}
/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {Object} e - data from the suggestion modal
 * @returns {Object} -promise
 */
function addressSelection(e) {
    var data = e.data.param;
    var url = data.updateUrl;
    var deferred = $.Deferred(); // eslint-disable-line
    var check = $('input[name=verifyaddress]:checked').val();
    var isMultiShip = $('#checkout-main').hasClass('multi-ship');
    var formSelector = isMultiShip ?
        '.multi-shipping .active form' : '.single-shipping .shipping-form';
    var shippingForm = $(formSelector);
    if (check === 'notfound-address') {
        $('#shippingAddressValidationModal').modal('hide');
        $('.modal-backdrop').hide();
        var isExpressCheckout = $('.express-checkout').length > 0;
        if (isExpressCheckout) {
            $('#editShippingAddressModal').modal('show');
        } else {
            $('.shipping-summary .edit-button', '#checkout-main').trigger('click');
        }
        return deferred.resolve();
    }
    if (check === 'entered-address') {
        $('.shippingAddressOne').val(data.enteredAddress.street);
        if (data.enteredAddress.street2) {
            $('.shippingAddressTwo').val(data.enteredAddress.street2);
        }
        $('.shippingAddressCity').val(data.enteredAddress.city);
        $('.shippingState').val(data.enteredAddress.state).change();
        $('.shippingZipCode').val(data.enteredAddress.zipcode);
        $('#shippingAddressValidationModal').modal('hide');
        var form = shippingForm.serializeArray();
        form.push({
            name: 'addressId',
            value: data.addressId
        },
            {
                name: 'enteredAddressStreet',
                value: data.enteredAddress.street
            },
            {
                name: 'shipmentAddressSelector',
                value: shipmentSelector
            });
        saveAddressToAccount(shippingForm);
        $('.modal-backdrop').hide();
        setTimeout(function () {
            if (url) {
                return $.ajax({
                    url: url,
                    method: 'POST',
                    data: form,
                    success: function (response) {
                        if (response.error) {
                            window.location.href = response.redirectUrl;
                        } else {
                            $('body').trigger('checkout:updateCheckoutView',
                                {
                                    order: response.order,
                                    customer: response.customer
                                });
                        }
                        return deferred.resolve();
                    }
                });
            }
            return deferred.resolve();
        }, 300);
    } else {
        $('.shippingAddressOne').val(data.suggestedAddress.street);
        $('.shippingAddressTwo').val(data.suggestedAddress.street2);
        $('.shippingAddressCity').val(data.suggestedAddress.city);
        $('.shippingState').val(data.suggestedAddress.state).change();
        $('.shippingZipCode').val(data.suggestedAddress.zipcode);
        $('#shippingAddressValidationModal').modal('hide');
        $('.modal-backdrop').hide();
        let forms = shippingForm.serializeArray();
        forms.push({
            name: 'addressId',
            value: data.addressId
        },
            {
                name: 'suggestedAddressStreet',
                value: data.suggestedAddress.street
            },
            {
                name: 'smartyRDI',
                value: data.responseAddressData.metadata.rdi
            },
            {
                name: 'shipmentAddressSelector',
                value: shipmentSelector
            });
        saveAddressToAccount(shippingForm);
        setTimeout(function () {
            if (url) {
                return $.ajax({
                    url: url,
                    method: 'POST',
                    data: forms,
                    success: function (response) {
                        if (response.error) {
                            window.location.href = response.redirectUrl;
                        } else {
                            $('body').trigger('checkout:updateCheckoutView',
                                {
                                    order: response.order,
                                    customer: response.customer
                                });
                            if (response.retailStateCodes.indexOf($('#shippingStatedefault :selected').val()) > -1) {
                                $('.retail-fee').empty().append(data.order.totals.retailFee.formatted);
                                $('.retail-delivery-fee').removeClass('d-none');
                            } else {
                                $('.retail-delivery-fee').addClass('d-none');
                            }
                        }
                        return deferred.resolve();
                    }
                });
            }
            return deferred.resolve();
        }, 300);
    }
    return deferred.resolve();
}

/**
 * Bind confirm / dismiss handlers for the address suggestion modal.
 * @param {jQuery} $modal - modal element
 * @param {Object} data - address suggestion response data
 * @param {Object} onConfirm - callback when user confirms selection
 * @param {Object} onDismiss - callback when modal is closed without confirming
 */
function bindAddressSuggestionHandlers($modal, data, onConfirm, onDismiss) {
    var modalConfirmed = false;

    $modal.off('hidden.bs.modal.addressFlow').on('hidden.bs.modal.addressFlow', function () {
        $modal.off('hidden.bs.modal.addressFlow');
        if (!modalConfirmed && onDismiss) {
            onDismiss();
        }
    });

    $modal.find('.selectedAdress').off('click.addressSuggestion').on('click.addressSuggestion', function (e) {
        e.preventDefault();
        modalConfirmed = true;
        addressValidationModal.suppressTriggerFocusOnHide();
        if (onConfirm) {
            onConfirm(e);
        }
    });
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} adressSuggestionUrl - url to be used to retrieve a new product model
 * @param {Object} form - shipping form
 * @returns {Object} - Promises
 */
function fillModalElement(adressSuggestionUrl, form) {
    var flowDefer = $.Deferred(); // eslint-disable-line
    addressValidationModal.setModalTrigger(document.activeElement);
    $.spinner().start();
    var shippingForm = form.serializeArray();
    shippingForm.push({
        name: 'sameShippingAddress',
        value: sameShippingAddress
    });
    $.ajax({
        url: adressSuggestionUrl,
        method: 'GET',
        dataType: 'json',
        data: shippingForm,
        success: function (data) {
            if (data.error) {
                flowDefer.reject(data);
                return;
            }

            if (data.renderedTemplate) {
                addressValidationModal.showModalAfterEditModals(data).done(function ($modal) {
                    bindAddressSuggestionHandlers($modal, data, function (e) {
                        addressSelection($.extend(e, { data: { param: data } }));
                        flowDefer.resolve(data);
                    }, function () {
                        flowDefer.reject();
                    });
                });
                sameShippingAddress = '';
                return;
            }

            if (!data.smartyStreetVerification && data.success) {
                saveAddressToAccount(form);
            } else if (data.isSmartyValidated || data.isSmartyValidationBypassed) {
                saveAddressToAccount(form);
            }
            sameShippingAddress = '';
            flowDefer.resolve(data);
        },
        error: function (err) {
            flowDefer.reject(err);
        },
        complete: function () {
            $.spinner().stop();
        }
    });
    return flowDefer.promise();
}

/**
  * Create an alert to display the error message
  * @param {Object} message - Error message to display
  */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.shipping-error').append(errorHtml);
    scrollAnimate($('.shipping-error'));
}

/**
 * smarty street adress suggestion
 * @param {Object} form - shipping form
 * @returns {Object} - Promises
 */
function addressSuggestion(form) {
    var adressSuggestionUrl = $('#checkout-submit-shipping').attr('data-url') || $('.btn-enter-multi-ship').data('url') || $('.update-shipping-address').attr('data-url');
    return fillModalElement(adressSuggestionUrl, form);
}
/**
 * updates the shipping address selector within shipping forms
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 * @param {Object} customer - the customer model
 */
function updateShippingAddressSelector(productLineItem, shipping, order, customer) {
    var uuidEl = $('input[value=' + productLineItem.UUID + ']');
    var shippings = order.shipping;

    var form = $('form[name$=shipping]')[0];
    var $shippingAddressSelector = $('.addressSelector', form);
    var hasSelectedAddress = false;

    if (uuidEl && uuidEl.length > 0) {
        form = uuidEl[0].form;
        $shippingAddressSelector = $('.addressSelector', form);
    }

    if ($shippingAddressSelector && $shippingAddressSelector.length === 1) {
        $shippingAddressSelector.empty();
        // Add New Address option
        if (!$shippingAddressSelector.data('isvetcor')) {
            $shippingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
                null,
                false,
                order
            ));
        }

        if (customer.addresses && customer.addresses.length > 0) {
            $shippingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
                order.resources.accountAddresses,
                false,
                order
            ));

            customer.addresses.forEach(function (address) {
                var isSelected = shipping.matchingAddressId === address.ID;
                hasSelectedAddress = hasSelectedAddress || isSelected;
                $shippingAddressSelector.append(
                    addressHelpers.methods.optionValueForAddress(
                        { UUID: 'ab_' + address.ID, shippingAddress: address },
                        isSelected,
                        order
                    )
                );
            });
        }
        // Separator -
        $shippingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            order.resources.shippingAddresses, false, order, { className: 'multi-shipping' }
        ));
        shippings.forEach(function (aShipping) {
            var isSelected = shipping.UUID === aShipping.UUID;
            hasSelectedAddress = hasSelectedAddress || isSelected;
            var addressOption = addressHelpers.methods.optionValueForAddress(
                aShipping,
                isSelected,
                order,
                { className: 'multi-shipping' }
            );

            var newAddress = addressOption.html() === order.resources.addNewAddress;
            var matchingUUID = aShipping.UUID === shipping.UUID;
            if ((newAddress && matchingUUID) || (!newAddress && matchingUUID) || (!newAddress && !matchingUUID)) {
                $shippingAddressSelector.append(addressOption);
            }
            if (newAddress && !matchingUUID) {
                $(addressOption[0]).remove();
            }
        });
    }

    if (!hasSelectedAddress) {
        // show
        $(form).addClass('hide-details');
    } else {
        $(form).removeClass('hide-details');
        $(form).attr('data-address-mode', 'edit');
    }

    $('body').trigger('shipping:updateShippingAddressSelector', {
        productLineItem: productLineItem,
        shipping: shipping,
        order: order,
        customer: customer
    });
}

/**
 * updates the shipping address form values within shipping forms
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingAddressFormValues(shipping) {
    var addressObject = $.extend({}, shipping.shippingAddress);

    if (!addressObject || (addressObject && $.isEmptyObject(addressObject))) {
        addressObject = {
            firstName: null,
            lastName: null,
            address1: null,
            address2: null,
            city: null,
            companyName: null,
            postalCode: null,
            stateCode: null,
            countryCode: 'US',
            phone: null
        };
    }

    addressObject.isGift = shipping.isGift;
    addressObject.giftMessage = shipping.giftMessage;

    $('input[value=' + shipping.UUID + ']').each(function (formIndex, el) {
        var form = el.form;
        if (!form) return;
        var countryCode = addressObject.countryCode;

        $('input[name$=_firstName]', form).val(addressObject.firstName);
        $('input[name$=_lastName]', form).val(addressObject.lastName);
        $('input[name$=_address1]', form).val(addressObject.address1);
        $('input[name$=_address2]', form).val(addressObject.address2);
        $('input[name$=_city]', form).val(addressObject.city);
        $('input[name$=_companyName', form).val(addressObject.companyName);
        $('input[name$=_postalCode]', form).val(addressObject.postalCode);
        $('select[name$=_stateCode],input[name$=_stateCode]', form)
            .val(addressObject.stateCode);

        if (countryCode && typeof countryCode === 'object') {
            $('select[name$=shippingCountry]', form).val(addressObject.countryCode.value);
            $('select[name$=country]', form).val(addressObject.countryCode.value);
        } else {
            $('select[name$=shippingCountry]', form).val(addressObject.countryCode);
            $('select[name$=country]', form).val(addressObject.countryCode);
        }

        $('input[name$=_phone]', form).val(addressObject.phone);

        $('input[name$=_isGift]', form).prop('checked', addressObject.isGift);
        $('textarea[name$=_giftMessage]', form).val(addressObject.isGift && addressObject.giftMessage ? addressObject.giftMessage : '');
    });

    $('body').trigger('shipping:updateShippingAddressFormValues', { shipping: shipping });
}

/**
 * Build an accessible label for a shipping method radio option.
 * @param {Object} shippingMethod - shipping method model
 * @returns {string} accessible label text
 */
function getShippingMethodAriaLabel(shippingMethod) {
    var ariaLabel = shippingMethod.displayName || '';

    if (shippingMethod.shippingCost) {
        ariaLabel += ', ' + shippingMethod.shippingCost;
    }

    return ariaLabel;
}

/**
 * updates the shipping method radio buttons within shipping forms
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingMethods(shipping) {
    var uuidEl = $('input[value=' + shipping.UUID + ']');
    var isExpressCheckout = $('.express-checkout').length > 0;

    if (uuidEl && uuidEl.length > 0) {
        $.each(uuidEl, function (shipmentIndex, el) {
            var form = isExpressCheckout ? $('.shipping-form') : el.form;
            if (!form) return;

            var $shippingMethodList = isExpressCheckout ? $('.shipping-method-list') : $('.shipping-method-list', form);

            if ($shippingMethodList && $shippingMethodList.length > 0) {
                $shippingMethodList.empty();
                var shippingMethods = shipping.applicableShippingMethods;
                var selected = shipping.selectedShippingMethod || {};
                var shippingMethodFormID = form.name + '_shippingAddress_shippingMethodID';
                //
                // Create the new rows for each shipping method
                //
                $.each(shippingMethods, function (methodIndex, shippingMethod) {
                    var tmpl = $('#shipping-method-template').clone();
                    var radioId = 'shippingMethod-' + shippingMethod.ID + '-' + shipping.UUID;
                    var nameId = 'shippingMethodName-' + shippingMethod.ID + '-' + shipping.UUID;
                    var costId = 'shippingMethodCost-' + shippingMethod.ID + '-' + shipping.UUID;
                    var arrivalId = 'shippingMethodArrival-' + shippingMethod.ID + '-' + shipping.UUID;
                    var $radio = $('input', tmpl);

                    $radio
                        .prop('id', radioId)
                        .prop('name', shippingMethodFormID)
                        .prop('value', shippingMethod.ID)
                        .attr('checked', shippingMethod.ID === selected.ID)
                        .attr('aria-label', getShippingMethodAriaLabel(shippingMethod))
                        .removeAttr('aria-labelledby');
                    if (shippingMethod.estimatedArrivalTime) {
                        $radio.attr('aria-describedby', arrivalId);
                    } else {
                        $radio.removeAttr('aria-describedby');
                    }
                    $radio
                        .parents('.shipping-method-item')
                        .toggleClass('selected-method', shippingMethod.ID === selected.ID);

                    $('label', tmpl)
                        .prop('for', radioId)
                        .attr('aria-hidden', 'true');
                    // set shipping method name
                    $('.display-name', tmpl)
                        .attr('id', nameId)
                        .text(shippingMethod.displayName);
                    // set shipping method custom description
                    if (shippingMethod.descriptionCustom) {
                        $('.text-small', tmpl).text(shippingMethod.descriptionCustom);
                    }
                    // set or hide arrival time
                    if (shippingMethod.estimatedArrivalTime) {
                        $('.arrival-time', tmpl)
                            .attr('id', arrivalId)
                            .html(shippingMethod.estimatedArrivalTime)
                            .show();
                    } else {
                        $('.arrival-time', tmpl).hide().removeAttr('id');
                    }
                    // set shipping cost
                    $('.shipping-cost', tmpl)
                        .attr('id', costId)
                        .text(shippingMethod.shippingCost);
                    $shippingMethodList.append(tmpl.html());
                });
            }
        });
    }

    $('body').trigger('shipping:updateShippingMethods', { shipping: shipping });
}

/**
 * Handle response from the server for valid or invalid form fields.
 * @param {Object} defer - the deferred object which will resolve on success or reject.
 * @param {Object} data - the response data with the invalid form fields or
 * @param {Object} shippingMethodList - object handle for spinner
 *  valid model data.
 */
function shippingFormResponse(defer, data, shippingMethodList) {
    var isMultiShip = $('#checkout-main').hasClass('multi-ship');
    var formSelector = isMultiShip
        ? '.multi-shipping .active form'
        : '.single-shipping form';

    // highlight fields with errors
    if (data.error) {
        if (data.fieldErrors.length) {
            data.fieldErrors.forEach(function (error) {
                if (Object.keys(error).length) {
                    formHelpers.loadFormErrors(formSelector, error);
                }
            });
            defer.reject(data);
            if (shippingMethodList) {
                shippingMethodList.spinner().stop();
                $.spinner().stop();
            }
        }

        if (data.serverErrors && data.serverErrors.length) {
            $.each(data.serverErrors, function (index, element) {
                createErrorNotification(element);
            });

            defer.reject(data);
        }

        if (data.cartError) {
            window.location.href = data.redirectUrl;
            defer.reject();
        }
    } else {
        $('body').trigger('checkout:updateCheckoutView', {
            order: data.order,
            customer: data.customer
        });
        if ($('.billingCountry :selected').val() === 'US') {
            $('.non-us-states').addClass('d-none');
            $('.ca-province').addClass('d-none');
            $('.us-states').removeClass('d-none');
            $('#province').val('OTHER');
        } else if ($('.billingCountry :selected').val() === 'CA') {
            $('.us-states').addClass('d-none');
            $('.non-us-states').addClass('d-none');
            $('.ca-province').removeClass('d-none');
            $('.billingState').val('OTHER');
        } else {
            $('.us-states').addClass('d-none');
            $('.ca-province').addClass('d-none');
            $('.non-us-states').removeClass('d-none');
            $('#province').val('OTHER');
            $('.billingState').val('OTHER');
        }
        if ($('#editShippingAddressModal.show').length > 0) {
            $('#editShippingAddressModal').modal('hide');
            $('#editShippingAddressModal').spinner().stop();
        }
        // remove the session variable
        if (window.sessionStorage.getItem('billingAddress')) {
            $('#sameAsShipping').prop('checked', false);
            var billingform = $('form[name=dwfrm_billing]');
            let $billingAddressBlock = $('.billing-address-block');
            let $addressSummary = $('.address-summary-wrapper');
            let $sameAsShippingCheckbox = $('.js-same-as-shipping');
            $billingAddressBlock.toggleClass('d-none', $sameAsShippingCheckbox.is(':checked'));
            $addressSummary.toggleClass('d-none', !$sameAsShippingCheckbox.is(':checked'));
            var sBillingAddress = window.sessionStorage.getItem('billingAddress');
            billingHelpers.methods.updateBillingInformation(
                data.order,
                data.customer,
                data.options
            );
            $(billingform).attr('data-address-mode', sBillingAddress[0]);
            window.sessionStorage.removeItem('billingAddress');
        }

        defer.resolve(data).then(() => {
            scrollAnimate($('.js-payment-methods-title'));
            $('#cardNumber').focus();
        });
    }
}

/**
 * Update list of available shipping methods whenever user modifies shipping address details.
 * @param {jQuery} $shippingForm - current shipping form
 * @returns {Object} - Promise
 */
function updateShippingMethodList($shippingForm) {
    var isExpressCheckout = $('.express-checkout').length > 0;
    var $shippingMethodList = isExpressCheckout ? $('.shipping-method-list') : $shippingForm.find('.shipping-method-list');

    if (!$shippingMethodList || !$shippingMethodList.length) {
        return $.Deferred().resolve(); // eslint-disable-line
    }

    if (!shippingMethodListUpdateDefer) {
        shippingMethodListUpdateDefer = $.Deferred(); // eslint-disable-line
    }
    shippingMethodListUpdateForm = $shippingForm;

    if (shippingMethodListUpdateTimer) {
        clearTimeout(shippingMethodListUpdateTimer);
    }

    // delay for autocomplete — coalesce rapid field changes into one request
    shippingMethodListUpdateTimer = setTimeout(function () {
        shippingMethodListUpdateTimer = null;
        var defer = shippingMethodListUpdateDefer;
        shippingMethodListUpdateDefer = null;
        var form = shippingMethodListUpdateForm;
        var $methodList = isExpressCheckout ? $('.shipping-method-list') : form.find('.shipping-method-list');

        var urlParams = addressHelpers.methods.getAddressFieldsFromUI(form);
        var shipmentUUID = isExpressCheckout ? $('.shipping-form').find('[name=shipmentUUID]').val() : form.find('[name=shipmentUUID]').val();
        var url = $methodList.data('actionUrl');
        urlParams.shipmentUUID = shipmentUUID;
        var addressSelector = $('.single-shipping .addressSelector');
        var selectedOption = $('option:selected', addressSelector);
        urlParams.addressSelector = selectedOption[0].value;
        $methodList.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    if (data.redirectUrl) {
                        window.location.href = data.redirectUrl;
                    } else {
                        shippingFormResponse(defer, data, $methodList);
                    }
                } else {
                    if (data.sameShippingAddress) {
                        sameShippingAddress = 'true';
                    } else {
                        sameShippingAddress = 'false';
                    }
                    $('body').trigger('checkout:updateCheckoutView',
                        {
                            order: data.order,
                            customer: data.customer,
                            options: { keepOpen: true }
                        });
                    shipmentSelector = data.order.shipmentSelector;
                    if ($('.billingCountry :selected').val() === 'US') {
                        $('.non-us-states').addClass('d-none');
                        $('.ca-province').addClass('d-none');
                        $('.us-states').removeClass('d-none');
                        $('#province').val('OTHER');
                    } else if ($('.billingCountry :selected').val() === 'CA') {
                        $('.us-states').addClass('d-none');
                        $('.non-us-states').addClass('d-none');
                        $('.ca-province').removeClass('d-none');
                        $('.billingState').val('OTHER');
                    } else {
                        $('.us-states').addClass('d-none');
                        $('.ca-province').addClass('d-none');
                        $('.non-us-states').removeClass('d-none');
                        $('#province').val('OTHER');
                        $('.billingState').val('OTHER');
                    }
                    if ($('#shippingCountrydefault :selected').val() === 'US') {
                        $('.us-states').removeClass('d-none');
                        $('.non-us-states').addClass('d-none');
                    } else {
                        $('.us-states').addClass('d-none');
                        $('.non-us-states').removeClass('d-none');
                        $('.shippingState').val('OTHER');
                    }
                    if (data.retailStateCodes.indexOf($('#shippingStatedefault :selected').val()) > -1) {
                        $('.retail-fee').empty().append(data.order.totals.retailFee.formatted);
                        $('.retail-delivery-fee').removeClass('d-none');
                    } else {
                        $('.retail-delivery-fee').addClass('d-none');
                    }
                    $methodList.spinner().stop();
                }
                defer.resolve();
            },
            error: function () {
                $.spinner().stop();
                defer.reject();
            }
        });
    }, 300);

    return shippingMethodListUpdateDefer;
}

/**
 * updates the order shipping summary for an order shipment model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 */
function updateShippingSummaryInformation(shipping, order) {
    $('[data-shipment-summary=' + shipping.UUID + ']').each(function (i, el) {
        var $container = $(el);
        var $shippingAddressLabel = $container.find('.shipping-addr-label');
        var $addressContainer = $container.find('.address-summary');
        var $shippingPhone = $container.find('.order-summary-phone');
        var $orderEmail = $container.find('.order-summary-email');
        var $methodTitle = $container.find('.shipping-method-title');
        var $methodArrivalTime = $container.find('.shipping-method-arrival-time');
        var $methodPrice = $container.find('.shipping-method-price');
        var $shippingSummaryLabel = $container.find('.shipping-method-label');
        var $summaryDetails = $container.find('.row.summary-details');
        var giftMessageSummary = $container.find('.gift-summary');

        var address = shipping.shippingAddress;
        var selectedShippingMethod = shipping.selectedShippingMethod;
        var isGift = shipping.isGift;
        addressHelpers.methods.populateAddressSummary($addressContainer, address);
        if ($('#sameAsShipping').length && $('#sameAsShipping').is(':checked')) {
            addressHelpers.methods.populateAddressSummary('.address-summary-wrapper .address-summary', address);
        }
        var addressSelector = $('.single-shipping .addressSelector');
        var selectedOption = $('option:selected', addressSelector);
        var shipmentUUID = selectedOption[0].value;
        if (shipmentUUID === 'new' && (!$('.address-summary .address1').html() || !$('.address-summary .firstName').html() || !$('.address-summary .lastName').html() || !$('.address-summary .city').html() || !$('.address-summary .postalCode').html() || !$('.address-summary .stateCode').html())) {
            $('.address-summary .address1').html('');
            $('.address-summary .address2').html('');
            $('.address-summary .companyName').html('');
            $('.address-summary .firstName').html('');
            $('.address-summary .lastName').html('');
            $('.address-summary .city').html('');
            $('.address-summary .postalCode').html('');
            $('.address-summary .stateCode').html('');
        }
        if (address !== null) {
            $shippingPhone.text(address.phone);
        }
        $orderEmail.text(order.orderEmail);

        if (selectedShippingMethod) {
            $('body').trigger('shipping:updateAddressLabelText',
                { selectedShippingMethod: selectedShippingMethod, resources: order.resources, shippingAddressLabel: $shippingAddressLabel });
            $shippingSummaryLabel.show();
            $summaryDetails.show();
            $methodTitle.text(selectedShippingMethod.displayName);
            if (selectedShippingMethod.estimatedArrivalTime) {
                $methodArrivalTime.text(selectedShippingMethod.estimatedArrivalTime);
            } else {
                $methodArrivalTime.empty();
            }
            $methodPrice.text(selectedShippingMethod.shippingCost);
        }

        if (isGift) {
            giftMessageSummary.find('.gift-message-summary').text(shipping.giftMessage);
            giftMessageSummary.removeClass('d-none');
        } else {
            giftMessageSummary.addClass('d-none');
        }
    });

    $('body').trigger('shipping:updateShippingSummaryInformation', { shipping: shipping, order: order });
}

/**
 * Update the read-only portion of the shipment display (per PLI)
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 * @param {Object} [options] - options for updating PLI summary info
 * @param {Object} [options.keepOpen] - if true, prevent changing PLI view mode to 'view'
 */
function updatePLIShippingSummaryInformation(productLineItem, shipping, order, options) {
    var $pli = $('input[value=' + productLineItem.UUID + ']');
    var form = $pli && $pli.length > 0 ? $pli[0].form : null;

    if (!form) return;

    var $viewBlock = $('.view-address-block', form);

    var address = shipping.shippingAddress || {};
    var selectedMethod = shipping.selectedShippingMethod;

    var nameLine = address.firstName ? address.firstName + ' ' : '';
    if (address.lastName) nameLine += address.lastName;

    var address1Line = address.address1;
    var address2Line = address.address2;

    var phoneLine = address.phone;

    var shippingCost = selectedMethod ? selectedMethod.shippingCost : '';
    var methodNameLine = selectedMethod ? selectedMethod.displayName : '';
    var methodArrivalTime = selectedMethod && selectedMethod.estimatedArrivalTime
        ? '(' + selectedMethod.estimatedArrivalTime + ')'
        : '';

    var tmpl = $('#pli-shipping-summary-template').clone();

    $('.ship-to-name', tmpl).text(nameLine);
    $('.ship-to-address1', tmpl).text(address1Line);
    $('.ship-to-address2', tmpl).text(address2Line);
    $('.ship-to-city', tmpl).text(address.city);
    if (address.stateCode) {
        $('.ship-to-st', tmpl).text(address.stateCode);
    }
    $('.ship-to-zip', tmpl).text(address.postalCode);
    $('.ship-to-phone', tmpl).text(phoneLine);

    if (!address2Line) {
        $('.ship-to-address2', tmpl).hide();
    }

    if (!phoneLine) {
        $('.ship-to-phone', tmpl).hide();
    }

    if (shipping.selectedShippingMethod) {
        $('.display-name', tmpl).text(methodNameLine);
        $('.text-small', tmpl).text(selectedMethod.descriptionCustom);
        $('.arrival-time', tmpl).text(methodArrivalTime);
        $('.price', tmpl).text(shippingCost);
    }

    if (shipping.isGift) {
        $('.gift-message-summary', tmpl).text(shipping.giftMessage);
        var shipment = $('.gift-message-' + shipping.UUID);
        $(shipment).val(shipping.giftMessage);
    } else {
        $('.gift-summary', tmpl).addClass('d-none');
    }
    // checking h5 title shipping to or pickup
    var $shippingAddressLabel = $('.shipping-header-text', tmpl);
    $('body').trigger('shipping:updateAddressLabelText',
        { selectedShippingMethod: selectedMethod, resources: order.resources, shippingAddressLabel: $shippingAddressLabel });

    $viewBlock.html(tmpl.html());

    $('body').trigger('shipping:updatePLIShippingSummaryInformation', {
        productLineItem: productLineItem,
        shipping: shipping,
        order: order,
        options: options
    });
}

/**
 * Update the hidden form values that associate shipping info with product line items
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateProductLineItemShipmentUUIDs(productLineItem, shipping) {
    $('input[value=' + productLineItem.UUID + ']').each(function (key, pli) {
        var form = pli.form;
        $('[name=shipmentUUID]', form).val(shipping.UUID);
        $('[name=originalShipmentUUID]', form).val(shipping.UUID);

        $(form).closest('.card').attr('data-shipment-uuid', shipping.UUID);
    });

    $('body').trigger('shipping:updateProductLineItemShipmentUUIDs', {
        productLineItem: productLineItem,
        shipping: shipping
    });
}

/**
 * Update the shipping UI for a single shipping info (shipment model)
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order/basket model
 * @param {Object} customer - the customer model
 * @param {Object} [options] - options for updating PLI summary info
 * @param {Object} [options.keepOpen] - if true, prevent changing PLI view mode to 'view'
 */
function updateShippingInformation(shipping, order, customer, options) {
    // First copy over shipmentUUIDs from response, to each PLI form
    order.shipping.forEach(function (aShipping) {
        aShipping.productLineItems.items.forEach(function (productLineItem) {
            updateProductLineItemShipmentUUIDs(productLineItem, aShipping);
        });
    });

    // Now update shipping information, based on those associations
    updateShippingMethods(shipping);
    updateShippingAddressFormValues(shipping);
    updateShippingSummaryInformation(shipping, order);

    // And update the PLI-based summary information as well
    shipping.productLineItems.items.forEach(function (productLineItem) {
        updateShippingAddressSelector(productLineItem, shipping, order, customer);
        updatePLIShippingSummaryInformation(productLineItem, shipping, order, options);
    });

    $('body').trigger('shipping:updateShippingInformation', {
        order: order,
        shipping: shipping,
        customer: customer,
        options: options
    });
}

/**
 * Update the checkout state (single vs. multi-ship)
 * @param {Object} order - checkout model to use as basis of new truth
 */
function updateMultiShipInformation(order) {
    var $checkoutMain = $('#checkout-main');
    var $checkbox = $('[name=usingMultiShipping]');
    var $submitShippingBtn = $('button.submit-shipping');
    $('.shipping-error .alert-danger').remove();

    if (order.usingMultiShipping) {
        $checkoutMain.addClass('multi-ship');
        $checkbox.prop('checked', true);
    } else {
        $checkoutMain.removeClass('multi-ship');
        $checkbox.prop('checked', null);
        $submitShippingBtn.prop('disabled', null);
    }

    $('body').trigger('shipping:updateMultiShipInformation', { order: order });
}

/**
 * Clear out all the shipping form values and select the new address in the drop down
 * @param {Object} order - the order object
 */
function clearShippingForms(order) {
    order.shipping.forEach(function (shipping) {
        $('input[value=' + shipping.UUID + ']').each(function (formIndex, el) {
            var form = el.form;
            if (!form) return;

            $('input[name$=_firstName]', form).val('');
            $('input[name$=_lastName]', form).val('');
            $('input[name$=_address1]', form).val('');
            $('input[name$=_address2]', form).val('');
            $('input[name$=_city]', form).val('');
            $('input[name$=_postalCode]', form).val('');
            $('select[name$=_stateCode],input[name$=_stateCode]', form).val('');
            $('select[name$=_shippingCountry]', form).val('');
            $('select[name$=_country]', form).val('');
            $('input[name$=_companyName]', form).val('');
            $('input[name$=_phone]', form).val('');

            $('input[name$=_isGift]', form).prop('checked', false);
            $('textarea[name$=_giftMessage]', form).val('');
            $(form).find('.gift-message').addClass('d-none');

            $(form).attr('data-address-mode', 'new');
            var addressSelectorDropDown = $('.addressSelector option[value=new]', form);
            $(addressSelectorDropDown).prop('selected', true);
        });
    });

    $('body').trigger('shipping:clearShippingForms', { order: order });
}

/**
 * Does Ajax call to create a server-side shipment w/ pliUUID & URL
 * @param {string} url - string representation of endpoint URL
 * @param {Object} shipmentData - product line item UUID
 * @returns {Object} - promise value for async call
 */
function createNewShipment(url, shipmentData) {
    $.spinner().start();
    return $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: shipmentData
    });
}

/**
 * Restore focus to the shipping method radio after the list is redrawn.
 * @param {jQuery} $methodList - shipping method list element
 * @param {Object} urlParams - request params including methodID and shipmentUUID
 */
function focusSelectedShippingMethodRadio($methodList, urlParams) {
    if (!$methodList || !$methodList.length || !urlParams || !urlParams.methodID) {
        return;
    }

    var radioId = 'shippingMethod-' + urlParams.methodID + '-' + urlParams.shipmentUUID;
    var $radio = $('#' + radioId);

    if (!$radio.length) {
        $radio = $methodList.find('input[value="' + urlParams.methodID + '"]');
    }

    if ($radio.length) {
        $radio.focus();
    }
}

/**
 * Does Ajax call to select shipping method
 * @param {string} url - string representation of endpoint URL
 * @param {Object} urlParams - url params
 * @param {Object} el - element that triggered this call
 */
function selectShippingMethodAjax(url, urlParams, el) {
    $.spinner().start();
    $('body').trigger('checkout:beforeShippingMethodSelected');
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: urlParams
    })
        .done(function (data) {
            if (data.error) {
                window.location.href = data.redirectUrl;
            } else {
                $('body').trigger('checkout:updateCheckoutView',
                    {
                        order: data.order,
                        customer: data.customer,
                        options: { keepOpen: true },
                        urlParams: urlParams
                    }
                );
                $('body').trigger('checkout:postUpdateCheckoutView',
                    {
                        el: el
                    }
                );
                if (data.sameShippingAddress) {
                    sameShippingAddress = 'true';
                } else {
                    sameShippingAddress = 'false';
                }
            }
            $('body').trigger('checkout:shippingMethodSelected', data);
            $.spinner().stop();

            if (!data.error) {
                setTimeout(function () {
                    focusSelectedShippingMethodRadio(el, urlParams);
                }, 0);
            }
        })
        .fail(function () {
            $.spinner().stop();
        });
}

/**
 * Hide and show to appropriate elements to show the multi ship shipment cards in the enter view
 * @param {jQuery} element - The shipping content
 */
function enterMultishipView(element) {
    element.find('.btn-enter-multi-ship').removeClass('d-none');

    element.find('.view-address-block').addClass('d-none');
    element.find('.shipping-address').addClass('d-none');
    element.find('.btn-save-multi-ship.save-shipment').addClass('d-none');
    element.find('.btn-edit-multi-ship').addClass('d-none');
    element.find('.multi-ship-address-actions').addClass('d-none');
}

/**
 * Hide and show to appropriate elements to show the multi ship shipment cards in the view mode
 * @param {jQuery} element - The shipping content
 */
function viewMultishipAddress(element) {
    element.find('.view-address-block').removeClass('d-none');
    element.find('.btn-edit-multi-ship').removeClass('d-none');

    element.find('.shipping-address').addClass('d-none');
    element.find('.btn-save-multi-ship.save-shipment').addClass('d-none');
    element.find('.btn-enter-multi-ship').addClass('d-none');
    element.find('.multi-ship-address-actions').addClass('d-none');
}

/**
 * Hide and show to appropriate elements that allows the user to edit multi ship address information
 * @param {jQuery} element - The shipping content
 */
function editMultiShipAddress(element) {
    // Show
    element.find('.shipping-address').removeClass('d-none');
    element.find('.btn-save-multi-ship.save-shipment').removeClass('d-none');

    // Hide
    element.find('.view-address-block').addClass('d-none');
    element.find('.btn-enter-multi-ship').addClass('d-none');
    element.find('.btn-edit-multi-ship').addClass('d-none');
    element.find('.multi-ship-address-actions').addClass('d-none');

    $('body').trigger('shipping:editMultiShipAddress', { element: element, form: element.find('.shipping-form') });
}

/**
 * perform the proper actions once a user has clicked enter address or edit address for a shipment
 * @param {jQuery} element - The shipping content
 * @param {string} mode - the address mode
 */
function editOrEnterMultiShipInfo(element, mode) {
    var form = $(element).closest('form');
    var root = $(element).closest('.shipping-content');

    $('body').trigger('shipping:updateDataAddressMode', { form: form, mode: mode });

    editMultiShipAddress(root);

    var addressInfo = addressHelpers.methods.getAddressFieldsFromUI(form);

    var savedState = {
        UUID: $('input[name=shipmentUUID]', form).val(),
        shippingAddress: addressInfo
    };

    root.data('saved-state', JSON.stringify(savedState));
}
module.exports = {
    methods: {
        addressSuggestion: addressSuggestion,
        updateShippingAddressSelector: updateShippingAddressSelector,
        updateShippingAddressFormValues: updateShippingAddressFormValues,
        updateShippingMethods: updateShippingMethods,
        updateShippingSummaryInformation: updateShippingSummaryInformation,
        updatePLIShippingSummaryInformation: updatePLIShippingSummaryInformation,
        updateProductLineItemShipmentUUIDs: updateProductLineItemShipmentUUIDs,
        updateShippingInformation: updateShippingInformation,
        updateMultiShipInformation: updateMultiShipInformation,
        shippingFormResponse: shippingFormResponse,
        createNewShipment: createNewShipment,
        selectShippingMethodAjax: selectShippingMethodAjax,
        updateShippingMethodList: updateShippingMethodList,
        clearShippingForms: clearShippingForms,
        editMultiShipAddress: editMultiShipAddress,
        editOrEnterMultiShipInfo: editOrEnterMultiShipInfo,
        createErrorNotification: createErrorNotification,
        viewMultishipAddress: viewMultishipAddress
    },

    initAddressValidationModal: function () {
        addressValidationModal.initAccessibility();
    },

    internationalCountryModal: function () {
        let $internationalShippingModal = $('#internationalCountryModal');
        let $addressModal = $('#editShippingAddressModal');

        // Show the modal if country selected is not US
        $(document).on('change', '#shippingCountrydefault', function () {
            if ($(this).val() !== 'US') {
                // Save data for GlobalE modal on cart
                window.sessionStorage.setItem('internationalShipping', $(this).val());
                $(this).val('US').trigger('change');

                $internationalShippingModal.modal('show');
                $addressModal.modal('hide');
            }
        });

        // Dump request data if user cancels the flow
        $internationalShippingModal.on('click', '[data-dismiss="modal"]', function () {
            window.sessionStorage.removeItem('internationalShipping');
            $addressModal.modal('show');
        });
    },

    selectShippingMethod: function () {
        var baseObj = this;

        $('.shipping-method-list').change(function () {
            var $shippingForm = $('.express-checkout').length > 0 ? $('.shipping-form') : $(this).parents('form');
            var methodID = $(':checked', this).val();
            var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
            var urlParams = addressHelpers.methods.getAddressFieldsFromUI($shippingForm);
            urlParams.shipmentUUID = shipmentUUID;
            urlParams.methodID = methodID;
            urlParams.isGift = $shippingForm.find('.gift').prop('checked');
            urlParams.giftMessage = $shippingForm.find('textarea[name$=_giftMessage]').val();

            var url = $(this).data('select-shipping-method-url');

            if (baseObj.methods && baseObj.methods.selectShippingMethodAjax) {
                baseObj.methods.selectShippingMethodAjax(url, urlParams, $(this));
            } else {
                selectShippingMethodAjax(url, urlParams, $(this));
            }
        });
    },

    toggleMultiship: function () {
        var baseObj = this;

        $('input[name="usingMultiShipping"]').on('change', function () {
            var url = $('.multi-shipping-checkbox-block form').attr('action');
            var usingMultiShip = this.checked;

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: { usingMultiShip: usingMultiShip },
                success: function (response) {
                    if (response.error) {
                        window.location.href = response.redirectUrl;
                    } else {
                        $('body').trigger('checkout:updateCheckoutView', {
                            order: response.order,
                            customer: response.customer
                        });

                        if ($('#checkout-main').data('customer-type') === 'guest') {
                            if (baseObj.methods && baseObj.methods.clearShippingForms) {
                                baseObj.methods.clearShippingForms(response.order);
                            } else {
                                clearShippingForms(response.order);
                            }
                        } else {
                            response.order.shipping.forEach(function (shipping) {
                                $('input[value=' + shipping.UUID + ']').each(function (formIndex, el) {
                                    var form = el.form;
                                    if (!form) return;

                                    $(form).attr('data-address-mode', 'edit');
                                    var addressSelectorDropDown = $(form).find('.addressSelector option[value="ab_' + shipping.matchingAddressId + '"]');
                                    $(addressSelectorDropDown).prop('selected', true);
                                    $('input[name$=_isGift]', form).prop('checked', false);
                                    $('textarea[name$=_giftMessage]', form).val('');
                                    $(form).find('.gift-message').addClass('d-none');
                                });
                            });
                        }

                        if (usingMultiShip) {
                            $('body').trigger('shipping:selectMultiShipping', { data: response });
                        } else {
                            $('body').trigger('shipping:selectSingleShipping', { data: response });
                        }
                    }

                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    selectSingleShipping: function () {
        $('body').on('shipping:selectSingleShipping', function () {
            $('.single-shipping .shipping-address').removeClass('d-none');
        });
    },

    selectMultiShipping: function () {
        var baseObj = this;

        $('body').on('shipping:selectMultiShipping', function (e, data) {
            $('.multi-shipping .shipping-address').addClass('d-none');

            data.data.order.shipping.forEach(function (shipping) {
                var element = $('.multi-shipping .card[data-shipment-uuid="' + shipping.UUID + '"]');

                if (shipping.shippingAddress) {
                    if (baseObj.methods && baseObj.methods.viewMultishipAddress) {
                        baseObj.methods.viewMultishipAddress($(element));
                    } else {
                        viewMultishipAddress($(element));
                    }
                } else {
                    /* eslint-disable no-lonely-if */
                    if (baseObj.methods && baseObj.methods.enterMultishipView) {
                        baseObj.methods.enterMultishipView($(element));
                    } else {
                        enterMultishipView($(element));
                    }
                    /* eslint-enable no-lonely-if */
                }
            });
        });
    },

    selectSingleShipAddress: function () {
        $('.single-shipping .addressSelector').on('change', function () {
            var cleaveUSPhoneConfig = {
                numericOnly: true,
                blocks: [0, 3, 0, 3, 4],
                delimiters: ['(', ')', ' ', '-'],
                delimiterLazyShow: true
            };
            var form = $(this).parents('form')[0];
            var selectedOption = $('option:selected', this);
            var attrs = selectedOption.data();
            var shipmentUUID = selectedOption[0].value;
            var originalUUID = $('input[name=shipmentUUID]', form).val();
            var element;
            Object.keys(attrs).forEach(function (attr) {
                element = attr === 'countryCode' ? 'country' : attr;
                $('[name$=' + element + ']', form).val(attrs[attr]);
            });
            $('.js-phone-format').toArray().forEach(function (fieldElement) {
                let $form = $(fieldElement).parents('form');

                // Only load cleave for US phone field
                if ($form.find('.js-country-validation').length && $form.find('.js-country-validation').val() === 'US') {
                    $(fieldElement).data('cleave', new Cleave(fieldElement, cleaveUSPhoneConfig));
                }
            });
            $('[name$=stateCode]', form).trigger('change');
            if (shipmentUUID === 'new') {
                $(form).attr('data-address-mode', 'new');
                $(form).find('.shipping-address-block').removeClass('d-none');
            } else if (shipmentUUID === originalUUID) {
                $(form).attr('data-address-mode', 'shipment');
                $('#email').val(selectedOption.data('email'));
            } else if (shipmentUUID.indexOf('ab_') === 0) {
                $(form).attr('data-address-mode', 'customer');
                $('#email').val(selectedOption.data('email'));
            } else {
                $(form).attr('data-address-mode', 'edit');
            }
            formHelpers.clearPreviousErrors(form);
        });
    },

    selectMultiShipAddress: function () {
        var baseObj = this;

        $('.multi-shipping .addressSelector').on('change', function () {
            var form = $(this).closest('form');
            var selectedOption = $('option:selected', this);
            var attrs = selectedOption.data();
            var shipmentUUID = selectedOption[0].value;
            var originalUUID = $('input[name=shipmentUUID]', form).val();
            var pliUUID = $('input[name=productLineItemUUID]', form).val();
            var createNewShipmentScoped = baseObj.methods && baseObj.methods.createNewShipment ? baseObj.methods.createNewShipment : createNewShipment;

            var element;
            Object.keys(attrs).forEach(function (attr) {
                if (attr === 'isGift') {
                    $('[name$=' + attr + ']', form).prop('checked', attrs[attr]);
                    $('[name$=' + attr + ']', form).trigger('change');
                } else {
                    element = attr === 'countryCode' ? 'country' : attr;
                    $('[name$=' + element + ']', form).val(attrs[attr]);
                }
            });

            if (shipmentUUID === 'new' && pliUUID) {
                var createShipmentUrl = $(this).attr('data-create-shipment-url');
                createNewShipmentScoped(createShipmentUrl, { productLineItemUUID: pliUUID })
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }

                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            }
                        );

                        $(form).attr('data-address-mode', 'new');
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            } else if (shipmentUUID === originalUUID) {
                $('select[name$=stateCode]', form).trigger('change');
                $(form).attr('data-address-mode', 'shipment');
            } else if (shipmentUUID.indexOf('ab_') === 0) {
                var url = $(form).attr('action');
                var serializedData = $(form).serialize();
                createNewShipmentScoped(url, serializedData)
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }

                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            }
                        );

                        $(form).attr('data-address-mode', 'customer');
                        var $rootEl = $(form).closest('.shipping-content');
                        editMultiShipAddress($rootEl);
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            } else {
                var updatePLIShipmentUrl = $(form).attr('action');
                var serializedAddress = $(form).serialize();
                createNewShipmentScoped(updatePLIShipmentUrl, serializedAddress)
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }

                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            }
                        );

                        $(form).attr('data-address-mode', 'edit');
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            }
        });
    },

    updateShippingList: function () {
        var isExpressCheckout = $('.express-checkout').length > 0;
        var baseObj = this;
        var shippingAddressFieldsSelector = '#shippingAddressOnedefault, #shippingAddressTwodefault, #shippingZipCodedefault';

        /**
         * Updates shipping methods when shipping address fields change.
         * @param {Event} e - change event
         */
        function onShippingAddressFieldChange(e) {
            if (isExpressCheckout) {
                return;
            }
            var $form = $(e.currentTarget.form);
            if (baseObj.methods && baseObj.methods.updateShippingMethodList) {
                baseObj.methods.updateShippingMethodList($form);
            } else {
                updateShippingMethodList($form);
            }
        }

        $(shippingAddressFieldsSelector).on('change', onShippingAddressFieldChange);
        $('select[name$="shippingAddress_addressFields_states_stateCode"]')
            .on('change', onShippingAddressFieldChange);
    },

    updateDataAddressMode: function () {
        $('body').on('shipping:updateDataAddressMode', function (e, data) {
            $(data.form).attr('data-address-mode', data.mode);
        });
    },

    enterMultiShipInfo: function () {
        var baseObj = this;

        $('.btn-enter-multi-ship').on('click', function (e) {
            e.preventDefault();

            if (baseObj.methods && baseObj.methods.editOrEnterMultiShipInfo) {
                baseObj.methods.editOrEnterMultiShipInfo($(this), 'new');
            } else {
                editOrEnterMultiShipInfo($(this), 'new');
            }
        });
    },

    editMultiShipInfo: function () {
        var baseObj = this;

        $('.btn-edit-multi-ship').on('click', function (e) {
            e.preventDefault();

            if (baseObj.methods && baseObj.methods.editOrEnterMultiShipInfo) {
                baseObj.methods.editOrEnterMultiShipInfo($(this), 'edit');
            } else {
                editOrEnterMultiShipInfo($(this), 'edit');
            }
        });
    },

    saveMultiShipInfo: function () {
        var baseObj = this;

        $('.btn-save-multi-ship').on('click', function (e) {
            e.preventDefault();

            // Save address to checkoutAddressBook
            var form = $(this).closest('form');
            var $rootEl = $(this).closest('.shipping-content');
            var data = $(form).serialize();
            var url = $(form).attr('action');

            $rootEl.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: data
            })
                .done(function (response) {
                    formHelpers.clearPreviousErrors(form);
                    if (response.error) {
                        if (response.fieldErrors && response.fieldErrors.length) {
                            response.fieldErrors.forEach(function (error) {
                                if (Object.keys(error).length) {
                                    formHelpers.loadFormErrors(form, error);
                                }
                            });
                        } else if (response.serverErrors && response.serverErrors.length) {
                            $.each(response.serverErrors, function (index, element) {
                                createErrorNotification(element);
                            });
                        } else if (response.redirectUrl) {
                            window.location.href = response.redirectUrl;
                        }
                    } else {
                        // Update UI from response
                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer
                            }
                        );

                        if (baseObj.methods && baseObj.methods.viewMultishipAddress) {
                            baseObj.methods.viewMultishipAddress($rootEl);
                        } else {
                            viewMultishipAddress($rootEl);
                        }
                    }

                    if (response.order && response.order.shippable) {
                        $('button.submit-shipping').attr('disabled', null);
                    }

                    $rootEl.spinner().stop();
                })
                .fail(function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }

                    $rootEl.spinner().stop();
                });

            return false;
        });
    },

    cancelMultiShipAddress: function () {
        var baseObj = this;

        $('.btn-cancel-multi-ship-address').on('click', function (e) {
            e.preventDefault();

            var form = $(this).closest('form');
            var $rootEl = $(this).closest('.shipping-content');
            var restoreState = $rootEl.data('saved-state');

            // Should clear out changes / restore previous state
            if (restoreState) {
                var restoreStateObj = JSON.parse(restoreState);
                var originalStateCode = restoreStateObj.shippingAddress.stateCode;
                var stateCode = $('[name$=_stateCode]', form).val();

                if (baseObj.methods && baseObj.methods.updateShippingAddressFormValues) {
                    baseObj.methods.updateShippingAddressFormValues(restoreStateObj);
                } else {
                    updateShippingAddressFormValues(restoreStateObj);
                }

                if (stateCode !== originalStateCode) {
                    $('[data-action=save]', form).trigger('click');
                } else {
                    $(form).attr('data-address-mode', 'edit');
                    if (baseObj.methods && baseObj.methods.editMultiShipAddress) {
                        baseObj.methods.editMultiShipAddress($rootEl);
                    } else {
                        editMultiShipAddress($rootEl);
                    }
                }
            }

            return false;
        });
    },

    isGift: function () {
        $('.gift').on('change', function (e) {
            e.preventDefault();
            var isExpressCheckout = $('.express-checkout').length > 0;

            var form = isExpressCheckout ? $('.express-checkout') : $(this).closest('form');

            if (this.checked) {
                $(form).find('.gift-message').removeClass('d-none');
            } else {
                $(form).find('.gift-message').addClass('d-none');
                $(form).find('.gift-message').val('');
            }
        });
    },

    hasCustomerPONumber: function () {
        $('.custponumber').on('change', function (e) {
            e.preventDefault();
            var isExpressCheckout = $('.express-checkout').length > 0;

            var form = isExpressCheckout ? $('.express-checkout') : $(this).closest('form');

            if (this.checked) {
                $(form).find('.custponumber-message').removeClass('d-none');
            } else {
                $(form).find('.custponumber-message').addClass('d-none');
                $(form).find('.custponumber-message').val('');
            }
        });
    },

    onShippingAddressUpdate: function () {
        if ($('.enableSmartyStreetsAutoComplete').data('enablesmartystreetsautocomplete')) {
            $('.shippingAddressTwo, .shippingAddressCity, .shippingZipCode').on('keyup', function () {
                window.sessionStorage.removeItem('shipping');
            });
            $('.shippingState').on('change', function () {
                window.sessionStorage.removeItem('shipping');
            });
        }
    }
};
